import React, { Component } from 'react';
import ISelectOption from '../../contactform/src/models/ISelectOption';
import FormError from '../../models/FormError';
import ErrorFieldMessage from './FieldErrorMessage.Component';

type SelectComponentProps<T> = {
    options: T[],
    onSelected: (selectedItem: T) => Promise<FormError[]>
    placeholderText: string,
    label: string,
    name: string,
    id: string,
    errors?: FormError[]
}

type SelectComponentState<T> = {
    selectedOption: T,
    open: boolean,
    errors: FormError[]
}

export default class SelectComponent<T extends ISelectOption> extends Component<SelectComponentProps<T>, SelectComponentState<T>> {
    constructor(props: SelectComponentProps<T>) {
        super(props);
        this.state = {
            selectedOption: { text: this.props.placeholderText } as T,
            open: false,
            errors: []
        }
    }

    public componentDidUpdate(previousProps: SelectComponentProps<T>, previousState: SelectComponentState<T>) {
        if (this.props.errors?.length != previousProps.errors?.length) {
            this.setState({
                errors: this.props.errors?.filter(err => { return err.field === this.props.name }) ?? []
            });
        }

        if (this.props.placeholderText !== previousProps.placeholderText) {
            this.setState({
                selectedOption: {
                    id: "-1",
                    text: this.props.placeholderText
                } as T
            })
        }
    }

    public async setSelectedOption(optionId: string) {
        let option: T;

        if (optionId === "-1") {
            option = {
                id: optionId,
                text: this.props.placeholderText
            } as T & ISelectOption;
        } else {
            option = this.props.options.find(o => o.id === optionId) as T & ISelectOption;
        }

        if (option) {
            const errors: FormError[] = await this.props.onSelected(option);

            this.setState({
                selectedOption: option,
                open: false,
                errors: errors
            });
        }
    }



    public render() {
        return (
            <div className="form-group">
                <label htmlFor={this.props.id} className="label">{this.props.label}</label>
                <select
                    id={this.props.id}
                    name={this.props.name}
                    className={"text-left btn bg-white w-100 p-2 d-flex trigger font-weight-bold border" + (!this.state.open ? " collapsed" : "")}
                    onChange={e => this.setSelectedOption(e.target.value)}
                    value={this.state.selectedOption.id}
                    defaultValue={this.state.selectedOption.id}
                >
                    <option value="-1">{this.props.placeholderText}</option>

                    {
                        this.props.options.map((option, index) => {
                            return (
                                <option
                                    key={option.text}
                                    value={option.id}
                                >
                                    {option.text}
                                </option>);
                        })
                    }
                </select>

                <ErrorFieldMessage name={this.props.name} errors={this.state.errors}></ErrorFieldMessage>
            </div>);
    }
}